import React from 'react';

function FormSegmentedControl({
  id,
  label,
  value,
  options,
  onChange,
  hint,
  error,
}) {
  return (
    <div>
      {label && (
        <span className="block text-sm font-medium text-slate-700 mb-2">{label}</span>
      )}
      <div
        className="flex items-stretch rounded-lg border border-surface-border bg-slate-50 p-1"
        role="group"
        aria-label={label}
      >
        {options.map((option) => {
          const selected = value === option.value;
          return (
            <button
              key={option.value}
              id={id ? `${id}-${option.value}` : undefined}
              type="button"
              aria-pressed={selected}
              onClick={() => onChange(option.value)}
              className={`flex flex-1 items-center justify-center text-sm min-h-[2.5rem] px-2 rounded-md transition-all ${
                selected
                  ? 'bg-white shadow-sm text-forge-800 font-medium'
                  : 'text-content-muted hover:text-content-primary'
              }`}
            >
              {option.label}
            </button>
          );
        })}
      </div>
      {hint && !error && (
        <p className="mt-1.5 text-xs text-content-muted">{hint}</p>
      )}
      {error && (
        <p className="mt-1.5 text-xs text-red-600">{error}</p>
      )}
    </div>
  );
}

export default FormSegmentedControl;
